import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import Departments from 'models/departments';
import { NavigationLink } from '../../Links/Links';
import NavigationMenuWrapper from './styled/NavigationMenuWrapper';
import NavigationContent from './NavigationContent';
import NavigationMenuNavTitle from './NavigationMenuNavTitle';
import MenuBackground from '../../Overlay';
import { useAppContext } from '../../../store/appContext';
import { useUrlBuilder } from '../../../hooks/useUrlBuilder';
import { track } from '../../../helpers/tracking/tracking';
import { categorySelectedEvent } from '../../../common/models/TrackingEvents';

const NavigationMenuDesktop = ({ department, hoverShown }) => {
  const {
    menu: { menu, hoverContent },
  } = useAppContext();
  const [navIndex, setNavIndex] = useState(null);
  const [transition, setTransition] = useState(false);
  const [menuToRender, setMenuToRender] = useState(
    menu.find(el => el.name.toLowerCase() === Departments.getInternalName(department)),
  );
  const { localized } = useUrlBuilder();
  const departmentInternalName = Departments.getInternalName(department);
  const hoverSale = hoverContent[`${departmentInternalName.toLowerCase()}_sale`];

  const getColor = useCallback(currentTab => (navIndex === null || navIndex === currentTab ? '#000' : '#999'), [
    navIndex,
  ]);

  useEffect(() => {
    setMenuToRender([]);
    setTransition(true);
  }, [department]);

  useEffect(() => {
    if (transition) {
      setTransition(false);
      setMenuToRender(menu.find(el => el.name.toLowerCase() === Departments.getInternalName(department)));
    }
  }, [department, menu, transition]);

  useEffect(() => {
    if (navIndex) {
      hoverShown();
    }
  }, [hoverShown, navIndex]);

  return (
    <NavigationMenuWrapper>
      {menu &&
        department &&
        menu.map(subMenu =>
          subMenu.children.map((menuColumn, index) => (
            <NavigationMenuNavTitle
              key={`${menuColumn.name}`}
              mouseOver={() => setNavIndex(index)}
              mouseLeave={() => setNavIndex(null)}
              hidden={departmentInternalName !== subMenu.name.toLowerCase()}
            >
              <NavigationLink
                id={`nav-link-${menuColumn.name}`}
                key={`${department}${menuColumn.name}`}
                color={menuColumn.name.toLowerCase() === 'sale' ? '#F25C5E' : getColor(index)}
                hoverColor={menuColumn.name.toLowerCase() === 'sale' ? '#F25C5E' : '#000'}
                underline={navIndex === index}
                href={localized(menuColumn.url)}
                data-cy={`nav-link-${menuColumn.name.toLowerCase()}`}
                padding={'0 30px 5px 0'}
                cursor="pointer"
                onClick={() => {
                  const category = menuColumn.name;
                  const payload = { categoryDepartment: { department: department.toLowerCase(), category } };
                  track(categorySelectedEvent, payload);
                }}
              >
                <span>{menuColumn.name}</span>
              </NavigationLink>

              {menuColumn.children.length > 0 && (
                <>
                  <NavigationContent
                    sales={menuColumn.name.toLowerCase() === 'sale'}
                    newIn={menuColumn.name.toLowerCase() === 'new in'}
                    hidden={navIndex !== index}
                    values={menuColumn}
                    hoverImage={hoverSale}
                    department={department}
                  />
                  {navIndex === index && <MenuBackground pointerEvents="none" />}
                </>
              )}
            </NavigationMenuNavTitle>
          )),
        )}
    </NavigationMenuWrapper>
  );
};

NavigationMenuDesktop.propTypes = {
  department: PropTypes.string,
  hoverShown: PropTypes.func,
};

export default NavigationMenuDesktop;
